import React from 'react';
import { Panel, PanelHeader, Group, Footer, Link, Div, Avatar, List, HeaderButton, Cell, Button, platform, IOS } from '@vkontakte/vkui';
import '@vkontakte/vkui/dist/vkui.css';
import Icon28ChevronBack from '@vkontakte/icons/dist/28/chevron_back';
import Icon24Back from '@vkontakte/icons/dist/24/back';
import Icon16Verified from '@vkontakte/icons/dist/16/verified';

var osname = platform();

function getdesc(count) {
	return String(count).replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, '$1 ') +
	' ' +
	 declOfNum(count, ['подписчик', 'подписчика', 'подписчиков']);
}

function declOfNum(number, titles) {  
    let cases = [2, 0, 1, 1, 1, 2];  
    return titles[ (number%100>4 && number%100<20)? 2 : cases[(number%10<5)?number%10:5] ];  
}

class MoreGid extends React.Component {

	replace_n(str) {
		let r = str;
		return (r.replace(/\n/g, "<br/>"));
	}

	render() {
		return (
			<Panel id={this.props.id}>

			{osname === IOS ? 
				<PanelHeader noShadow left={<HeaderButton onClick={() => this.props.SetActivePanel('home')} > <Icon28ChevronBack />  </HeaderButton>}>
					Информация
				</PanelHeader>
			 : 
				<PanelHeader  left={<HeaderButton onClick={() => this.props.SetActivePanel('home')} > <Icon24Back /> </HeaderButton>}>
					Информация
				</PanelHeader>
			}

				<Group>
					
						<List>	
							<Cell key={this.props.targetGid.id} size="m" before={<Avatar src={this.props.targetGid.photo_200}/>} description={getdesc(this.props.targetGid.members_count)}>
								{`${this.props.targetGid.name}`} {(this.props.targetGid.verified === 1) ? <Icon16Verified className="VerifiedIcon" /> : null}
							</Cell>
						</List>
					<Div className="mt0">
						<Button className="mt12" size="xl" onClick={
							() => { 
								this.props.SkipResult()
								this.props.GetResult(this.props.targetGid.id)
								this.props.SetActivePanel('result')
							}
						}>
							Анализировать
						</Button>
					</Div>
				</Group>

				{this.props.targetGid.description &&
					<Group title="Описание">
						<Div className="mt0">
							{this.props.targetGid.description.split('\n').map((item, key) => {
								return <span key={key}>{item}<br/></span>
							})}
						</Div>
					</Group>
				}
				<Footer>
					<Link target="_blank" className="CustomLink" href="https://vk.com/club39599132">Группа</Link>
					<Link target="_blank" className="CustomLink" href="https://vk.com/@kupiapp-servis-smm-analiz">О приложении</Link>
				</Footer>
			</Panel>
		)
	}
}



export default MoreGid;



// WEBPACK FOOTER //
// ./src/panels/MoreGid.js